<template>
    <v-layout row>      
        <v-flex xs12 sm12>         
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon small title="View attendance today" to="/myattendance/daily" >
                        <v-icon>today</v-icon>
                    </v-btn>
                    <v-btn dark icon title="View this month" @click="getThisMonth">
                        <v-icon>far fa-calendar-alt</v-icon>
                    </v-btn>
                    <help-link appId="attendance" pageId="mycalendar" color="white"></help-link>
                    <v-spacer></v-spacer>
                    <v-btn dark icon title="Previous Month"  @click="getPrevOrNext(-1)" :disabled="loading" style="margin-right:-11px;">
                        <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <v-toolbar-title class="subheading transparent white--text">{{ startMonth | moment("MMM YYYY") }}</v-toolbar-title>
                    <v-btn dark icon title="Next Month" @click="getPrevOrNext(1)" :disabled="loading">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>
                </v-toolbar>
                <!-- <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear> -->
            </v-card>
            
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>

            <v-layout row wrap> 
                <v-flex xs12>                    
                    <v-card class="elevation-1"> 
                        <v-sheet height="500" style="background-color: aquamarine">
                            <v-calendar
                                ref="calendar"
                                v-model="startMonth"
                                :now="today"
                                :value="today"
                                >
                                <template v-slot:day="{ date }">
                                    <template v-for="event in eventsMap[date]">
                                        <!-- holiday -->
                                        <v-menu :key="event.transDate" v-model="event.menuHoliday" full-width offset-x>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-if="event.holiday" v-on="on">
                                                    {{event.holiday}}
                                                </v-chip>
                                            </template> 
                                            <v-card max-width="400px" flat>
                                                <v-toolbar flat height="45px">
                                                    <b v-if="event.holiday">
                                                        {{event.holiday}}
                                                    </b>   
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                                <v-card-text>
                                                    <div v-if="event.holiday">
                                                        {{event.holidayType}}
                                                    </div>                                          
                                                </v-card-text>
                                            </v-card> 
                                        </v-menu>

                                        <!-- attendance, workshifts, corrections, timeoffs -->
                                        <v-menu :key="event.transDate" v-model="event.open" full-width offset-x>
                                            <template v-slot:activator="{ on }">
                                                <v-card-text v-if="event.clockStart==null && event.clockIn==null && !event.withPTO" v-ripple class="my-event text-xs-right" v-on="on" style="margin-top:-40px;">
                                                    <v-btn icon small>
                                                        <v-icon small>more_vert</v-icon>
                                                    </v-btn>
                                                </v-card-text>
                                                <!-- workshift -->
                                                <v-card-text v-if="event.clockStart" v-ripple class="my-event text-xs-center" v-on="on" :style="`background-color:${event.workShiftColor}`" title="Workshift">
                                                    <v-icon small class="icon">date_range</v-icon> {{event.clockStart | moment('h:mma')}} - {{event.clockEnd | moment('h:mma')}}
                                                </v-card-text>
                                                
                                                <!-- attendance -->
                                                <v-card-text v-if="event.clockIn" v-ripple class="my-event text-xs-center border" v-on="on" title="Attendance">
                                                    <v-icon small class="icon">schedule</v-icon> 
                                                    {{event.clockIn | moment('h:mma')}} - 
                                                    <span v-if="event.clockOut">{{event.clockOut | moment('h:mma')}}</span>
                                                    <span v-else>None</span>
                                                </v-card-text>

                                                <!-- attendance corrections -->
                                                <v-card-text v-if="event.withAttendanceCorrections" v-ripple class="my-event text-xs-center border" v-on="on" title="Attendance Corrections">
                                                   <span v-if="event.attCorrectionsWithUnApproved==1" class="warning--text">Attendance Corrections</span>
                                                   <span v-else class="green--text">Attendance Corrections</span>
                                                </v-card-text>
                                                
                                                <!-- Time Off -->
                                                <v-card-text v-if="event.withPTO" v-ripple class="my-event text-xs-center border" v-on="on" title="PTO">
                                                    <span v-if="event.timeOffWithUnApproved==1" class="warning--text">Time Off</span>
                                                    <span v-else class="green--text">Time Off</span>
                                                </v-card-text>
                                            </template> 
                                            <v-card max-width="400px" flat>
                                                <v-toolbar flat height="45px">
                                                    <span class="font-weight-bold header">{{ event.transDate | moment('dddd, MMMM DD YYYY') }}</span>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                                <v-card-text primary-title dark>
                                                    <div>
                                                        <b>Workshift:</b> 
                                                        <span v-if="event.workShift"> {{ event.workShift }} {{event.clockIn | moment('h:mma')}} - {{event.clockOut | moment('h:mma')}} <span v-if="event.strict">Strict</span> <span v-if="!event.strict">Flexible</span> </span>
                                                        <span v-else> Not assigned</span>
                                                    </div>
                                                    <div>
                                                        <b>Clock-In:</b> {{ event.clockIn == null ? "None" : event.clockIn | moment('h:mm a') }}, <b>Clock-Out:</b> {{ event.clockOut == null ? "None" : event.clockOut | moment('h:mm a') }}, <span v-if="event.totalHours!=null"><b>Total (h:m)</b>: {{ event.totalHours }} </span>
                                                    </div>
                                                    <div v-if="event.withPTO"><b>PTO:</b> {{ event.ptoDescription }} (<span class="caption" v-if="event.timeOffWithUnApproved==1">Not Approved</span><span lass="caption" v-if="event.timeOffWithUnApproved==0">Approved</span>)</div>
                                                </v-card-text>
                                                <v-divider></v-divider>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn v-if="$moment(event.transDate).format('YYYY-MM-DD')==$moment(serverDate).format('YYYY-MM-DD')" icon to="/myattendance/daily" title="Clock-In Now">
                                                        <v-icon>timer</v-icon>
                                                    </v-btn>
                                                    <v-btn v-if="$moment(event.transDate).format('YYYY-MM-DD')!=$moment(serverDate).format('YYYY-MM-DD')" icon @click="viewDaily(event.transDate)" title="View Attendance Details">
                                                        <v-icon>pageview</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-menu>
                                    </template>
                                </template>
                            </v-calendar>
                        </v-sheet>
                    </v-card>
                </v-flex>
            </v-layout>
            <br>
        </v-flex>
    </v-layout>
</template>

<script>

import attendanceApi from '@/api/attendance'

export default {
    name: 'MyCalendar',
    metaInfo: {
        title: 'My Calendar',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View monthly summary in Calendar view - attendance, time off, corrections, task charges' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink')
    },
    data() {
        return {
            toggle_view: 2,
            loading: false,
            error: false,
            errorMessage: '',
            serverDate: '',
            selectedDate: null,
            timezone: '',
            is_currently_dst: false,
            today: null,
            attendance_month: [],
            startMonth: null,
            curentTimestamp: Date.now(),
        }
    },
    methods: {
        viewDaily(transDate) {
            this.$router.push('/myattendance/daily/' + this.$moment(transDate).format('YYYY-MM-DD')) 
        },
        open (event) {
            alert(event.title)
        },
        viewToday() {
            this.$router.push('/myattendance/daily') 
        },
        async getThisMonth(){
            this.serverDate = Date.now()
            this.selectedDate = Date.now()
            this.today = this.$moment(Date.now()).format("YYYY-MM-DD")

            try {
                this.loading = true
                const response = await attendanceApi.getCalendarByUser(this.$moment(this.serverDate).format("YYYY-MM-DD"))
                if (response && response.status == 200) {
                    this.attendance_month = response.data.myCalendar
                    this.selectedDate = response.data.serverDate.local_date
                    this.today = this.$moment(response.data.serverDate.local_date).format("YYYY-MM-DD")
                    this.startMonth = this.$moment(response.data.serverDate.local_date).format("YYYY-MM-DD")
                }
                this.loading = false

                this.setHeaderThisMonth()
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getPrevOrNext(month){
            //month: -1 (prev month), 1 (next month)
            try {
                this.selectedDate = this.$moment(this.selectedDate).add(month, 'month')
                this.today = this.$moment(this.selectedDate).format("YYYY-MM-DD")
                this.startMonth = this.$moment(this.selectedDate).format("YYYY-MM-DD")

                const response = await attendanceApi.getCalendarByUser(this.$moment(this.selectedDate).format("YYYY-MM-DD"))
                if (response && response.status == 200) {
                    this.attendance_month = response.data.myCalendar
                }

                //update header titles
                this.$root.$emit('setHeaderTitles', {
                    display: true,
                    headerTitle: '',
                    headerPageTitle: `My Calendar | ${this.$moment(this.startMonth).format('MMMM YYYY')}`
                })
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        setHeaderThisMonth() {
            this.$root.$emit('setHeaderTitles', {
                display: true,
                headerTitle: '',
                headerPageTitle: `My Calendar | ${this.$moment(new Date()).format('MMMM YYYY')}`
            })
        }
    },
    computed: {
        eventsMap () {
            const map = {}
            this.attendance_month.forEach(e => (map[this.$moment(e.transDate).format("YYYY-MM-DD")] = map[this.$moment(e.transDate).format("YYYY-MM-DD")] || []).push(e))
            return map
        }
    },
    created() {
        this.setHeaderThisMonth()
        this.getThisMonth()
    },
}
</script>
<style scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;  
    width: 100%;
    font-size: 12px;
    padding: 1px;
    cursor: pointer;
    margin-bottom: 1px;
  }
  .border {
    border: 1px solid #E0E0E0;
  }
  .icon {
    margin-top:2px;
  }
  .header {
    margin-left:-10px;
  }
  .forreview {
    color: orange;
  }
  .approved {
    color: green;
  }
</style>
